import { Dayjs } from 'dayjs'
import { ComponentProps } from 'react'

import { AstraDatePopover, AstraInputProps, AstraInputWrapper, astraTwMerge } from '~/astra'

export type DatePickerFieldProps = AstraInputProps &
    Partial<ComponentProps<typeof AstraDatePopover>> & {
        onChange: (value: Dayjs | undefined) => void
        value: Dayjs | undefined
    }

export const DatePickerField = ({
    className,
    value,
    onChange,
    label,
    helperText,
    errorText,
    fullWidth = true,
    disabled,
    error,
    ...datePopoverProps
}: DatePickerFieldProps) => (
    <AstraInputWrapper
        fullWidth={fullWidth}
        label={label}
        helperText={helperText}
        errorText={errorText}
        borderless
        className={astraTwMerge('px-0', className)}
        disabled={disabled}
        error={error}
    >
        <AstraDatePopover
            buttonFullWidth={fullWidth}
            value={value}
            onChange={onChange}
            disabled={disabled}
            unit="day"
            allowClear
            placeholder="-"
            {...datePopoverProps}
        />
    </AstraInputWrapper>
)
